import { FileText } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'
import { MemberOnboardingMedicalPlanPlanType } from 'utils/web_api.schemas'

const PLAN_TYPE_OPTIONS: ComboboxFilterOption<string>[] = Object.entries(MemberOnboardingMedicalPlanPlanType).map(([key, value]) => ({
  label: key.toUpperCase(),
  value,
}))

const PlanTypeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = PLAN_TYPE_OPTIONS.filter(
    filterByLabelAndValueCallback(query)
  )

  // Ensure selectedValues is always an array
  const selectedValues = props.selectedValues || []

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        selectedValues={selectedValues}
        options={[
          { groupLabel: 'Plan types', options: filteredOptions },
        ]}
        placeholder='Search plan types to filter...'
        onValueChange={setQuery}
      >
        <button
          type='button'
          className='w-full'
          style={{ all: 'unset', cursor: 'pointer' }}
        >
          <FilterManagementDropdown
            {...props}
            selectedValues={selectedValues}
            options={PLAN_TYPE_OPTIONS}
            noSelectionText='Plan Type'
            pluralIdentifier='plan types'
          >
            <FileText size={20} />
          </FilterManagementDropdown>
        </button>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default PlanTypeFilter
